<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="85%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :createButtonDisabled="!$can('create','Storage')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"        
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    extraData: {},
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_BUILDING_LEVEL_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.buildingLevel;
          // this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));        
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseNew.closeDialog();
        // console.log("ids", this.entry);
        // var self = this;
        // this.entry.storageItemLotIdsAttribute.forEach(function(id, i){
          // self.entry.items.push(self.extraData.accountContext.allItemsInStorage.find( (item) => item.id == id));
        // });
        this.$emit("entry-created", this.entry);   
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_BUILDING_LEVEL_QUERY = gql `
  {
    accountContext {        
      buildingLevel{
        id
        name
        buildingLevelBoxesAttributes{
          id
          name
        }
        validations        
      }
    }
  }
`;

</script>

<style scoped></style>
